export const legacyFixedUiEnglish: Readonly<Record<string, string>> = Object.freeze({
  '返回首页': 'Back to Home',
  '返回上一页': 'Back',
  '返回': 'Back',
  '返回目录': 'Back to Menu',
  '返回选择场景': 'Back to Scenarios',
  '返回选择': 'Back to Selection',
  '其他服务': 'Other Services',
  '确认，下一步': 'Confirm & Continue',
  '确定，下一步': 'Continue',
  '推荐': 'Recommended',
  '切换中英文': 'Switch language',
  '实时公告': 'Live Notices',
  '查看公告记录': 'View notice history',
  '公告记录': 'Notice History',
  '关闭公告记录': 'Close notice history',
  '公告颜色说明': 'Notice color guide',
  '颜色说明': 'Color guide',
  '一般信息': 'General',
  '重要提醒': 'Important',
  '当前活动暂无公告': 'No notices for this event',
  '公告数据加载失败': 'Failed to load notices',
  '广播详情': 'Notice Details',
  '查看详情': 'View Details',
  '广播图片': 'Notice image',
  '广播图片预览': 'Notice image preview',
  '关闭图片预览': 'Close image preview',
  '广播图片大图': 'Full-size notice image',
  '旋转图片': 'Rotate image',
  '我已知晓，关闭提醒': 'Acknowledge and close',
  '关闭实时公告': 'Close live notices',
  '打开实时公告': 'Open live notices',
  '最新消息': 'Latest',
  '紧急公告': 'Emergency Notice',
  '现场公告信息': 'On-Site Notices',
  '查看上次路线': 'View Last Route',
  '继续查看上次入场路线': 'Continue Last Entry Route',
  '继续查看上次离场路线': 'Continue Last Exit Route',
  '选择场景': 'Choose a Scenario',
  '360 度全景': '360° Panorama',
  '我要入场': 'Enter the Venue',
  '我要离场': 'Leave the Venue',
  '从城市交通到场馆入口，再到看区座位。': 'From city transportation to the venue entrance and your seating area.',
  '从看区出口到轨道站、公交站、停车场和网约车点。': 'From your seating-area exit to metro, bus, parking, or ride-hailing pickup points.',
  '交通方式': 'Transportation',
  '入场模式': 'Entry Mode',
  '离场模式': 'Exit Mode',
  '方位总览': 'Venue Overview',
  '入场总览': 'Entry Overview',
  '离场总览': 'Exit Overview',
  '场馆、公交、轨道、网约车、自驾与封控边界合并呈现。': 'View the venue, bus, metro, ride-hailing, driving, and restricted boundaries together.',
  '以场馆为起点，拆解各出口与交通接驳点的离场方向。': 'Start from the venue and review exit directions to each transportation connection.',
  '入场指引': 'Entry Guide',
  '离场指引': 'Exit Guide',
  '选择看区': 'Choose a Seating Area',
  '路线详情': 'Route Details',
  '服务详情': 'Service Details',
  '区域路线': 'Area Route',
  '入场须知': 'Admission Notice',
  '本场活动暂未配置入场须知': 'No admission notice is available for this event.',
  '返回入场目录': 'Back to Entry Menu',
  '查看入场总览': 'View Entry Overview',
  '白天入场底图，仅确认入口、安检、检票、看区与封控方位。': 'Use the daytime overview to locate entrances, security, ticket gates, seating areas, and restricted zones.',
  '选择到达方式': 'Choose How You Arrive',
  '你是怎么来的？': 'How Are You Arriving?',
  '选择你的到达方式，下一步查看清晰路线。': 'Choose how you are arriving, then view the detailed route.',
  '按轨道、公交、停车、网约车拆分入场路径，下一步再选票区/看区。': 'Choose metro, bus, parking, or ride-hailing first, then select your ticket gate and seating area.',
  '下一步先选交通方式，再选择票区/看区。': 'Choose your transportation first, then select your ticket gate and seating area.',
  '换种交通方式': 'Choose Another Transport Option',
  '返回交通方式': 'Back to Transportation',
  '具体检票口': 'Ticket Gate',
  '选择出发地': 'Choose a Starting Point',
  '选择后更新下方路线': 'Choose one to update the route below.',
  '请选择出发地': 'Please choose a starting point',
  '组合路线图': 'Combined route map',
  '选择检票口查看对应路线图': 'Choose a ticket gate to view its route.',
  '请选择检票口': 'Please choose a ticket gate',
  '前往': 'Go to',
  '检票口': 'Ticket Gate',
  '你的票在哪个区域？': 'Where Is Your Seat?',
  '选择你的观演区域，继续查看入场动线。': 'Choose your seating area to continue viewing the entry route.',
  '当前路线没有可选座位区域': 'No seating area is available for this route',
  '请返回更换检票口，或联系现场工作人员。': 'Choose another ticket gate or ask on-site staff for help.',
  '换看区': 'Choose Another Area',
  '生成我的动线': 'Generate My Route',
  '入场方式': 'Entry Method',
  '步行路线': 'Walking Route',
  '到达观演区': 'Arrive at Seating Area',
  '选择离场交通方式': 'Choose Exit Transportation',
  '选择离场去向': 'Choose an Exit Destination',
  '你要去哪里？': 'Where Are You Going?',
  '选择离场交通方式，查看对应出口方向。': 'Choose your exit transportation to view the corresponding exit direction.',
  '选择你的出发看区': 'Choose Your Starting Seating Area',
  '根据所在看区匹配最近出口与推荐离场路径。': 'Match your seating area with the nearest exit and recommended departure route.',
  '下一步只展示散场方向，不混入入场票区。': 'Next, choose an exit direction without mixing in entry seating areas.',
  '请选择离场地点': 'Please choose an exit destination',
  '生成离场动线': 'Generate Exit Route',
  '出场路线步骤': 'Exit Route Steps',
  '离场方式': 'Exit Method',
  '离场路线': 'Exit Route',
  '失物招领': 'Lost Property',
  '失物招领处': 'Lost Property Office',
  '我丢了东西': 'I Lost an Item',
  '我捡到东西': 'I Found an Item',
  '认领核验': 'Claim Verification',
  '保管与移交': 'Storage & Handover',
  '联系失物招领处': 'Contact Lost Property',
  '位置待配置': 'Location pending',
  '服务时间': 'Service Hours',
  '联系电话': 'Phone',
  '返回其他服务': 'Back to Other Services',
  '服务项': 'Service',
  '待补充': 'Details pending',
  '也可长按识别二维码': 'You can also press and hold to scan the QR code.',
  '点单二维码': 'Ordering QR code',
  '路线预览': 'Route Preview',
  '封控边界': 'Restricted Boundary',
  '保存路线': 'Save Route',
  '路线图片已生成': 'Route image generated',
  '路线卡生成中': 'Generating route card',
  '路线卡已生成下载': 'Route card downloaded',
  '已请求浏览器下载 PNG 路线卡，请检查下载列表': 'The PNG route card download was requested. Check your browser downloads.',
  '已生成 PNG 路线卡，长按图片保存': 'Route card generated. Press and hold the image to save it.',
  '微信内不支持自动下载，已打开 PNG 路线卡，请长按保存': 'Automatic downloads are unavailable in WeChat. The PNG route card is open; press and hold it to save.',
  '请长按路线卡，选择“保存到照片”；若没有此选项，请在系统设置中允许微信访问照片。': 'Press and hold the route card and choose “Save to Photos”. If that option is missing, allow WeChat to access Photos in system settings.',
  '请长按路线卡，选择“保存图片”；若保存失败，请检查微信的照片和视频或存储权限。': 'Press and hold the route card and choose “Save image”. If saving fails, check WeChat photo, video, or storage permissions.',
  '请长按路线卡并选择保存图片；若保存失败，请检查微信的照片或存储权限。': 'Press and hold the route card and choose Save image. If saving fails, check WeChat photo or storage permissions.',
  '当前浏览器不支持直接下载，请长按路线卡保存图片。': 'This browser cannot download directly. Press and hold the route card to save the image.',
  '当前浏览器不支持直接下载，已打开 PNG 路线卡': 'This browser cannot download directly. The PNG route card is open.',
  '自动下载失败，请长按路线卡保存图片；若仍失败，请检查浏览器下载或照片权限。': 'Automatic download failed. Press and hold the route card to save it; if that still fails, check browser download or photo permissions.',
  '请长按路线卡保存图片；若保存失败，请检查浏览器下载或照片权限。': 'Press and hold the route card to save it. If saving fails, check browser download or photo permissions.',
  '路线卡预览加载失败，请关闭后重试': 'The route card preview failed to load. Close it and try again.',
  '路线图加载失败，暂不能保存路线卡，请检查网络后重试': 'The route map failed to load, so the route card cannot be saved. Check your connection and try again.',
  '看区路线图加载失败，暂不能保存路线卡，请检查网络后重试': 'The seating-area route map failed to load, so the route card cannot be saved. Check your connection and try again.',
  '路线卡二维码加载失败，暂不能保存路线卡，请检查网络后重试': 'The route-card QR code failed to load, so the route card cannot be saved. Check your connection and try again.',
  '路线卡图片受跨域限制，暂不能保存，请稍后重试': 'The route-card image is blocked by cross-origin restrictions and cannot be saved. Try again later.',
  '路线卡图片': 'Route card image',
  '路线卡图片生成失败': 'Failed to generate route card image',
  '重新选择': 'Start Over',
  '路线指引完成': 'Route Ready',
  '祝你观演愉快！': 'Enjoy the event!',
  '请有序离场，注意安全。': 'Please leave in an orderly manner and stay safe.',
  '到达地点': 'Destination',
  '选择后生成对应离场路线': 'Choose a destination to generate an exit route.',
  '地点信息': 'Location Details',
  '地图导航': 'Map Navigation',
  '选择高德地图或百度地图': 'Choose Amap or Baidu Maps',
  '选中并返回': 'Select & Return',
  '导航到': 'Navigate to',
  '打开导航': 'Open Navigation',
  '打开地图网页版': 'Open Web Map',
  '关闭地图选择': 'Close map selection',
  '选择地图导航': 'Choose Map Navigation',
  '查看总览大图': 'View Full Overview',
  '选择后切换地点图片': 'Select to view location image',
  '选择后生成对应路线': 'Select to generate route',
  '已选择': 'Selected',
  '选择': 'Select',
  '到达': 'Arrive at',
  '抵达': 'Arrive at',
  '路线': 'Route',
  '点位详情': 'Point Details',
  '标注点位': 'Annotation Point',
  '查看点位详情': 'View Point Details',
  '点位说明': 'Point Description',
  '现场图片': 'On-site Photos',
  '关闭': 'Close',
  '点击放大': 'Tap to enlarge',
  '标注地图': 'Annotated Map',
  '点击查看大图': 'Tap to view full image',
  '返回游客导视': 'Back to Visitor Guide',
  '正在进入体育馆': 'Entering the venue',
  '正在加载高清全景': 'Loading the high-resolution panorama',
  '全景漫游': 'Panorama Tour',
  'VR 总览': 'VR Overview',
  'VR 看区': 'VR Seating Area',
  '全景': 'Panorama',
  '上下左右拖动查看完整场馆。': 'Drag in any direction to explore the full venue.',
  '开始探索': 'Start Exploring',
  '拖动环视': 'Drag to Look Around',
  '体育馆看台': 'Stadium Seating',
  '全景浏览体育馆。': 'Explore the venue in 360°.',
  '全景浏览体育馆看区。': 'Explore the stadium seating area in 360°.',
  '选择 VR 总览场景': 'Choose a VR Overview Scene',
  '全景控制': 'Panorama Controls',
  '缩小': 'Zoom Out',
  '放大': 'Zoom In',
  '开启自动巡航': 'Start Auto-Rotation',
  '开启陀螺仪': 'Enable Gyroscope',
  '进入全屏': 'Enter Fullscreen',
  '展开全景控制': 'Expand Panorama Controls',
  '收起全景控制': 'Collapse Panorama Controls',
  '正在校验 manifest 并按视角加载瓦片': 'Verifying the manifest and loading panorama tiles',
})
